const env = process.env.REACT_APP_ENV;

let envApiUrl = '';
let envMenuUrl = '';
let envPaymentsUrl = '';
let envStripeKey = '';
let envPromotionsUrl = '';
let envSquareKey = '';
let envSquareLocation = '';

if (env === 'production') {
  envApiUrl = `https://${process.env.REACT_APP_DOMAIN_PROD}`;
  envMenuUrl = `https://${process.env.REACT_APP_MENU_APP_DOMAIN_PROD}`;
  envPaymentsUrl = `https://${process.env.REACT_APP_PAYMENT_DOMAIN_PROD}`;
  envPromotionsUrl = `https://${process.env.REACT_APP_PROMO_DOMAIN_PROD}`;
  envStripeKey = process.env.REACT_APP_STRIPE_LIVE;
  envSquareKey = process.env.REACT_APP_SQUARE;
  envSquareLocation = process.env.REACT_APP_SQUARE_LOCATION;
} else if (env === 'staging') {
  envApiUrl = `https://${process.env.REACT_APP_DOMAIN_STAG}`;
  envMenuUrl = `https://${process.env.REACT_APP_MENU_APP_DOMAIN_STAG}`;
  envPaymentsUrl = `https://${process.env.REACT_APP_PAYMENT_DOMAIN_STAG}`;
  envPromotionsUrl = `http://${process.env.REACT_APP_PROMO_DOMAIN_STAG}`;
  envStripeKey = process.env.REACT_APP_STRIPE_DEV;
  envSquareKey = process.env.REACT_APP_SQUARE_DEV;
  envSquareLocation = process.env.REACT_APP_SQUARE_LOCATION_DEV;
} else {
  envApiUrl = `https://${process.env.REACT_APP_DOMAIN_DEV}`;
  envMenuUrl = `https://${process.env.REACT_APP_MENU_APP_DOMAIN_DEV}`;
  envPaymentsUrl = `https://${process.env.REACT_APP_PAYMENT_DOMAIN_DEV}`;
  envPromotionsUrl = `https://${process.env.REACT_APP_PROMO_DOMAIN_DEV}`;
  envStripeKey = process.env.REACT_APP_STRIPE_DEV;
  envSquareKey = process.env.REACT_APP_SQUARE_DEV;
  envSquareLocation = process.env.REACT_APP_SQUARE_LOCATION_DEV;
}

export const apiUrl = envApiUrl;
export const menuUrl = envMenuUrl;
export const paymentsUrl = envPaymentsUrl;
export const appName = process.env.REACT_APP_NAME;
export const stripeKey = envStripeKey;
export const promotionsUrl = envPromotionsUrl;
export const squareKey = envSquareKey;
export const squareLocation = envSquareLocation;

export const zendeskKey = process.env.REACT_APP_ZENDESK;

export const cloudfront = `https://d2b8t2l9x5xm7h.cloudfront.net/public`;

if (env === 'production') {
  console.log = () => {};
}
